export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_q02_b.f0845f3e.png";